import { Globe, ShieldCheck, Gift, Lock } from "lucide-react";

const BADGES = [
  { icon: Globe, label: "UK-hosted", hint: "AWS eu-west-2 (London)" },
  { icon: ShieldCheck, label: "GDPR compliant", hint: "ICO registered" },
  { icon: Gift, label: "30-day free trial", hint: "No card required" },
  { icon: Lock, label: "AES-256 encrypted", hint: "At rest & in transit" },
];

export function TrustBadges({ className = "", variant = "dark" }) {
  const dark = variant === "dark";
  return (
    <ul className={`flex flex-wrap gap-2 ${className}`} data-testid="trust-badges" aria-label="Trust and security">
      {BADGES.map((b) => (
        <li
          key={b.label}
          title={b.hint}
          data-testid={`trust-badge-${b.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[12px] font-medium transition-colors ${
            dark
              ? "border-white/10 bg-white/[0.03] text-slate-300 hover:border-[#00D4AA]/40"
              : "border-navy-200 bg-white text-navy-700 hover:border-emerald-400"
          }`}
        >
          <b.icon className="h-3.5 w-3.5" style={{ color: dark ? "#00D4AA" : "#1FAF8B" }} strokeWidth={2} />
          {b.label}
        </li>
      ))}
    </ul>
  );
}
